import React, { useEffect, useState } from "react";
import Header from "../common/Header";
import { Button, Drawer, Toolbar } from "devextreme-react";
import { Item } from "devextreme-react/toolbar";
import { useSelector } from "react-redux";
import AuditDocumentGrid from "./AuditDocumentGrid";
import { useNavigate } from "react-router-dom";
import AuditDocumentPDFViewer from "./AuditDocumentPDFViewer";

export default function AuditDocumentViewer() {
  const [opened, setOpened] = useState(true);

  const selectedDoc = useSelector(
    (state) => state.auditDocumentViewer.selectedDoc
  );
  const employeeNo = useSelector((state) => state.userInfo.employeeNo);

  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Audit for CSL Bering";

    if (employeeNo == null) {
      navigate("/");
    }
  }, []);

  const onClickMenu = () => {
    setOpened(!opened);
  };

  const renderAuditDocumentGrid = (props) => {
    return <AuditDocumentGrid {...props} />;
  };

  return (
    <React.Fragment>
      <Header title={"Audit for CSL Bering"} menuDataSource={null} />
      <Toolbar>
        <Item location={"before"}>
          <Button
            text={opened ? "Hide List" : "Show List"}
            type="success"
            stylingMode="outlined"
            onClick={onClickMenu}
          />
        </Item>
        {!opened && (
          <Item
            location={"before"}
            text={`${selectedDoc != null ? `${selectedDoc.docTitle}` : ``}`}
          />
        )}
      </Toolbar>
      <Drawer
        opened={opened}
        openedStateMode="shrink"
        position="left"
        revealMode="slide"
        render={renderAuditDocumentGrid}
      >
        <div id="AuditDocumentViewer">
          <AuditDocumentPDFViewer opened={opened} />
        </div>
      </Drawer>
    </React.Fragment>
  );
}
